module.exports = __webpack_public_path__ + "static/productsans-medium-webfont-d1c199bb11595ba0b02fc16c5657c5a3.woff2";